module.exports = __webpack_public_path__ + "assets/img/lh_info.f5c36f57.png";